import angular from 'angular';

import component from './sponsoredFinanceAd.component';
import service from './sponsoredFinanceAd.service';

import NgAd from 'cars-ng-ad';

export default angular.module('vdp.shared.sponsoredFinanceAd', [
    NgAd
])

.component('carsSponsoredFinanceAd', component)
.service('sponsoredFinanceAdService', service)
.filter('months', [function () {
    return function(input) {
        return input && input.replace('months', 'mo.');
    };
}])

.name;
